const prefilled = {
  sentryUrl: 'https://b259ac8762464ecb8791dbe4386798b3@o327828.ingest.sentry.io/5699451',
  socketUrl: process.env.REACT_APP_Socket || 'http://localhost:8080'
}

export default prefilled;